// taskfetch.js

import { Task } from '@/classes/task.js'

export class TaskFetch extends Task {
    constructor(component, category, executor) {
        super(executor)

        // public variables
        this.component = component
        this.category = category
    }

    clone() {
        const newTask = new TaskFetch(
            this.component,
            this.category, 
            this._executor
        )

        return new Promise((resolve) => {
            resolve(newTask)
        })
    }
}
